import auth from "../../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import withValueField from "../../Shared/withValueField";
import { IDropDownModel } from "../../Shared/Models/IDropDownModel";
import { ErrorComponent } from "../../ReusableComponents";
import { successToastr } from "../../../HelperMethods";
import { ServiceCategoryIds } from "../../Shared/AppConstants";

const CustomDropDownList = withValueField(DropDownList);

export interface OverrideBillRateAndExpensesProps {
    candSubmissionId: string;
    dataItem?: any;
    onCloseModal?: any;
    onOverrideClose?: any;
}

export interface OverrideBillRateAndExpensesState {
    clientId: string;
    serviceTypes: Array<IDropDownModel>;
    serviceTypeId?: string;
    billRate?: number;
    holidayBillRate?: number;
    comment?: string;
    showLoader?: boolean;
}

class OverrideBillRateAndExpenses extends React.Component<OverrideBillRateAndExpensesProps, OverrideBillRateAndExpensesState> {
    public isSaveClicked = false;
    constructor(props: OverrideBillRateAndExpensesProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            serviceTypeId: this.props.dataItem.serviceTypeId,
            billRate: this.props.dataItem.billRate,
            holidayBillRate: this.props.dataItem.holidayBillRate,
            comment: "",
            serviceTypes: [],
            showLoader: true,
        };
    }

    componentDidMount() {
        this.getServiceTypes(this.props.candSubmissionId, this.state.clientId, this.props.dataItem.serviceCatId);
    }

    getServiceTypes = (candSubmissionId, clientId, id) => {
        axios.get(`api/candidates/candsub/servicetype?candSubmissionId=${candSubmissionId}&clientId=${clientId}&serviceCatId=${id}`).then((res) => {
            this.setState({ serviceTypes: res.data, showLoader: false });
        });
    }

    handleChange = (e) => {
        let { name, value, type } = e.target;
        this.state[name] = isNaN(value) ? value : Math.abs(value);
        this.setState(this.state);
    };

    handleUpdate = () => {
        this.isSaveClicked = true;
        let data = {
            candSubId: this.props.candSubmissionId,
            subBillRateId: this.props.dataItem.subBillRateId,
            serviceCategoryId: this.props.dataItem.serviceCategoryIntId,
            ServiceTypeId: this.state.serviceTypeId,
            billRate: this.state.billRate,
            holidayBillRate: this.state.holidayBillRate,
            comment: this.state.comment,
        };
        axios.put(`api/candidates/overridebillrate`, JSON.stringify(data)).then((res) => {
                successToastr("Rates updated successfully");
                this.props.onOverrideClose();
            });
    }

    render() {
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {"Update Rates"}
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 2 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 3 }).map((item, j) => (
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div>
                            <div className="row mt-3 mx-0">
                                <div className="col-12 col-sm-6 col-lg-4 mt-2 mt-sm-2">
                                    <label className="mb-1 font-weight-bold required">Service Type</label>
                                    <CustomDropDownList
                                        disabled={true}
                                        className="form-control"
                                        data={this.state.serviceTypes}
                                        name="serviceType"
                                        textField="name"
                                        valueField="id"
                                        value={this.state.serviceTypeId}
                                        id="serviceTypes"
                                    />
                                    {
                                        this.isSaveClicked && (this.state.serviceTypeId == "" || this.state.serviceTypeId == undefined) && <ErrorComponent />
                                    }
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4 mt-2 mt-sm-2">
                                    <label className="mb-1 font-weight-bold required">Bill Rate</label>
                                    <NumericTextBox
                                        className="form-control"
                                        placeholder="Enter Bill Rate"
                                        value={isNaN(this.state.billRate) ? 0 : this.state.billRate}
                                        format="c2"
                                        min={0}
                                        max={99999}
                                        name="billRate"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                    {
                                        this.isSaveClicked && (this.state.billRate === undefined || this.state.billRate === 0) && <ErrorComponent />
                                    }
                                </div>
                                {(this.props.dataItem.serviceCategoryIntId == ServiceCategoryIds.TIME) &&
                                    <div className="col-12 col-sm-6 col-lg-4 mt-2 mt-sm-2">
                                        <label className="mb-1 font-weight-bold required">Holiday Bill Rate</label>
                                        <NumericTextBox
                                            className="form-control"
                                            placeholder="Enter Holiday Bill Rate"
                                            value={isNaN(this.state.holidayBillRate) ? 0 : this.state.holidayBillRate}
                                            format="c2"
                                            min={0}
                                            max={99999}
                                            name="holidayBillRate"
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                        {
                                            this.isSaveClicked && (this.state.holidayBillRate === undefined || this.state.holidayBillRate === 0) && <ErrorComponent />
                                        }
                                    </div>
                                }
                                <div className="col-12 col-sm-6 col-lg-4 mt-2 mt-sm-2">
                                    <label className="mb-1 font-weight-bold">Comments</label>
                                    <textarea
                                        className="form-control"
                                        name="comment"
                                        placeholder="Enter Comments"
                                        value={this.state.comment || ""}
                                        maxLength={2000}
                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    )}


                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleUpdate}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default OverrideBillRateAndExpenses;